// extracted by mini-css-extract-plugin
export var deleteIcon = "_r3-5";
export var deleteOption = "_r3-3";
export var divider = "_r3-2";
export var downloadIcon = "_r3-4";
export var drawer = "_r3-0";
export var drawerFooter = "_r3-6";
export var drawerOpen = "_r3-1";
export var highlighted = "_r3-7";
export var lighterHighlight = "_r3-8";